import { isTextListType, normalizeTextList } from '../utils/valuePresentation';

function FieldLabel({ label, children }) {
    return (
        <label style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
            {label}
            {children}
        </label>
    );
}

export default function TemplateValueField({ field, value, onChange }) {
    if (isTextListType(field.type)) {
        const items = normalizeTextList(value);
        return (
            <FieldLabel label={field.label}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
                    {items.map((item, index) => (
                        <div key={index} style={{ display: 'flex', gap: '0.25rem' }}>
                            <input className="input-field" value={item} onChange={event => onChange(items.map((entry, i) => i === index ? event.target.value : entry))} style={{ margin: 0, flex: 1 }} />
                            <button type="button" className="btn-secondary" onClick={() => onChange(items.filter((_, i) => i !== index))}>Remove</button>
                        </div>
                    ))}
                    <button type="button" className="btn-secondary" onClick={() => onChange([...items, ''])} style={{ alignSelf: 'flex-start' }}>Add item</button>
                </div>
            </FieldLabel>
        );
    }

    if (field.type === 'imageList') {
        const items = Array.isArray(value) ? value : [];
        return (
            <FieldLabel label={field.label}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
                    {items.map((item, index) => (
                        <div key={index} style={{ display: 'flex', gap: '0.25rem' }}>
                            <input className="input-field" placeholder="Image URL" value={item?.url || ''} onChange={event => onChange(items.map((entry, i) => i === index ? { ...entry, url: event.target.value } : entry))} style={{ margin: 0, flex: 1 }} />
                            <input className="input-field" placeholder="Caption" value={item?.label || ''} onChange={event => onChange(items.map((entry, i) => i === index ? { ...entry, label: event.target.value } : entry))} style={{ margin: 0, width: '120px' }} />
                            <button type="button" className="btn-secondary" onClick={() => onChange(items.filter((_, i) => i !== index))}>Remove</button>
                        </div>
                    ))}
                    <button type="button" className="btn-secondary" onClick={() => onChange([...items, { url: '', label: '' }])} style={{ alignSelf: 'flex-start' }}>Add image</button>
                </div>
            </FieldLabel>
        );
    }

    const inputType = field.type === 'number' || field.type === 'currency' ? 'number' : field.type === 'color' ? 'color' : field.type === 'url' || field.type === 'image' ? 'url' : 'text';
    return (
        <FieldLabel label={field.label}>
            <input className="input-field" type={inputType} value={value ?? ''} onChange={event => onChange(event.target.value)} style={{ margin: 0 }} />
        </FieldLabel>
    );
}
